import React, {Component} from 'react';
import config from 'react-global-configuration';
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
//import {Card, CardBody, CardText} from 'reactstrap';
import {Card} from 'react-bootstrap';
import {Link} from "react-router-dom";
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactTooltip from 'react-tooltip';
import Switch from "react-switch";
import $ from 'jquery';
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class BrandProductMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            brand_file_uploaded: [],
            mvalue: { year: new Date().getFullYear(), month: 11 },
            _notificationSystem: null,
            timer: null,
            loading: true,
            isSubmit: false,
            file_name: "",
            notify: null,
            activer:[],
            is_download: false,
            uploadDropdown: false,
            errorModel: false,
            noErrorModel: false,
            file_id_got: null,
            report_file_name: null,
            error_message: null,
            error_message_header: null,
            open_instructions: false,
            emiMenus:[],
            report_download_name: null
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        this.getPartyID();
        //var _notificationSystem = this.refs.notificationSystem;
        // this.getBrandUploadedData();
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            //console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            this.getBrandUploadedData();
        });
    }


    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    openInstructions(){
        this.setState({
            open_instructions: !this.state.open_instructions
        });
        
    }

    onChangeHandler = event => {
        if (event.target.files.length == 0){
            this.handleNotificationClick("tr", 3, "Please select a file");
        }
        else{
            var file = event.target.files[0];
            var ext = this.getFileExtension(file.name);
            if (ext === 'csv') {
                this.setState({
                    selectedFile: file,
                    file_name: file.name
                });
            } else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    selectedFile: file
                });
            }
        }
        
    };

    handleChange(checked) {
        console.log(this.state.checked);
        //console.log(e.target.value);
        this.setState({
            checked
        });
        //this.setState({
        //    changedItems: {...this.state.changedItems, [id]:e.target.value},
        //    isChange: true
        //});
    }

    getBrandUploadedData(){
        if ($.fn.DataTable.isDataTable('#brandViewTable')) {
            $('#brandViewTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_brand_data', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            console.log(response);
            response.data.map((value, index) => {
                let status = false;
                if(value.active_status===1) { status = true;}
                this.setState({
                    activer: {...this.state.activer, [value.id]:status }
                });
            });
            this.setState({
                brand_file_uploaded: response.data,
                loading: false
            });
            $('#brandViewTable').DataTable({
                "oLanguage": {
                    "sEmptyTable": "You have not uploaded any files"
                }
            });
        });
        return null;
    }

    downloadCSV = (file_id, file_value) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_csv?file_id=" + file_id,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= null;
                console.log(file_value);
                console.log(xhr.getResponseHeader('Content-Disposition'));
                if(file_id == '7xhmd38Hhdad3_brand_product_master_template.csv'){
                    fileName = 'products-template.csv';
                }
                else{
                    fileName= file_value;
                }
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    downloadReportCSV = (file_id, file_value, file_value2) => {
        this.setState({
            is_download:false
        });
        let xhr = $.ajax({
            url: config.get('API_URL') + "/brandemi/download_report_csv?file_id=" + file_value,
            type: 'GET',
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "application/csv"
                });
                let fileName= file_value2;
                console.log(file_value);
                console.log(xhr.getResponseHeader('Content-Disposition'));
                //alert(fileName);
                let rfile = fileName.replace(/\"/g, "");
                // console.log(fileName);
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                console.log(a);
                window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true
                })
            }.bind(this)
        });
        this.setState({
            xhr:xhr
        })
    };

    fileUploadHandler = () => {
        const timer1 = (Date.now()).toString();
        //console.log(timer1);
        this.setState({
            timer: timer1,
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        data.append('userID', decoded._id);
        data.append('timer', this.state.timer);
        data.append('timer1', timer1);
        // let random_string = Date.now()+'_'+req.body.userID+'_';
        console.log(decoded.userGroup);
        data.append('userGroup', decoded.userGroup);
        data.append('party_master_id', this.state.party_master_id);
        if(this.state.selectedFile == null){
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit: false,
                loading: false
            });
        }
        else{
            var file = this.state.selectedFile; //console.log(data);
            var ext = this.getFileExtension(file.name);
            if (ext === 'csv') {
                axios.post(config.get('API_URL') + "/brandemi/new_upload", data, {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    }
                })
                .then(res => {
                    console.log(res.data);
                    this.setState({
                        file_id_got: res.data.file_id,
                        report_file_name: res.data.report_file_name,
                        report_download_name: res.data.report_download_name
                    });
                    //console.log(res.data.notify);
                    //console.log(res.data.inconsistent);
                    if (res.data.flag == -1){
                        this.handleNotificationClick("tr", 3, "Something Wrong");
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            report_download_name: res.data.report_download_name,
                            error_message: '',
                            error_message_header: 'Something Wrong',
                            error_message: '0' + '/' + '0',
                            error_message_header: 'Failure'
                        });
                    }
                    else if (res.data.flag == 2){
                        this.handleNotificationClick("tr", 2, "File with same name uploaded. Please change file name and continue.");
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            report_download_name: res.data.report_download_name,
                            error_message: '',
                            error_message_header: 'Duplicate File',
                            error_message: '0' + '/' + '0',
                            error_message_header: 'Failure'
                        });
                    }
                    else if(res.data.flag == 3){
                        this.handleNotificationClick("tr", 3, "No valid data to upload. File not uploaded");
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            report_download_name: res.data.report_download_name,
                            error_message: res.data.total_value + '/' + res.data.total,
                            error_message_header: 'Failure'
                        });
                        
                    }
                    else if(res.data.flag == 4){
                        this.handleNotificationClick("tr", 3, "Columns are incorrect in your csv");
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            report_download_name: res.data.report_download_name,
                            error_message: res.data.total_value + '/' + res.data.total,
                            error_message_header: 'Failure'
                        });
                    }
                    else if (res.data.flag == 5){
                        this.handleNotificationClick("tr", 3, "File is not in csv utf-8 format.");
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            report_download_name: res.data.report_download_name,
                            error_message: '',
                            error_message_header: 'Duplicate File',
                            error_message: '0' + '/' + '0',
                            error_message_header: 'Failure'
                        });
                    }
                    else if (res.data.flag == 6){
                        this.handleNotificationClick("tr", 3, "No data present in uploaded csv");
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            report_download_name: res.data.report_download_name,
                            error_message: '',
                            error_message_header: 'Empty Template',
                            error_message: '0' + '/' + '0',
                            error_message_header: 'Failure'
                        });
                    }
                    else if (res.data.success !== undefined && res.data.notify !== undefined && res.data.inconsistent === 0 && res.data.error2 === 0) {
                        this.setState({
                            isSubmit: false,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            report_download_name: res.data.report_download_name,
                            error_message: res.data.total_value + '/' + res.data.total
                        });
                        console.log("call show method on success");
                        this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                        this.toggleNoErrorModel.bind(this);
                        this.setState({
                            error_message_header: 'Success'
                        })
                        this.getBrandUploadedData();
                    } 
                    
                    else {
                        if (res.data.error2 === 1){
                            this.setState({
                                error_message_header: 'Failure'
                            })
                        }
                        else{
                            this.handleNotificationClick("tr", 1, "The file has been uploaded successfully.");
                            this.toggleNoErrorModel.bind(this);
                            this.setState({
                                error_message_header: 'Success'
                            })
                        }
                        this.setState({
                            isSubmit: false,
                            error_message: res.data.total_value + '/' + res.data.total,
                            loading: false,
                            notify: res.data.notify,
                            file_id_got: res.data.file_id,
                            report_file_name: res.data.report_file_name,
                            report_download_name: res.data.report_download_name
                        });
                        this.getBrandUploadedData();
                    }
                })
                .catch(err => { 
                    console.log(err);// then print response status
                    this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit: false,
                        loading: false
                    });
                    // this.openSectionToMap(true); // remove and place in success block
                })
            }
            else {
                this.handleNotificationClick("tr", 3, "Please upload valid file");
                this.setState({
                    isSubmit: false,
                    loading: false
                });
            }
        }
    };

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }

    activeHandler = () => {
        this.setState({
            isSubmit: true,
            loading: true
        });
        if(this.state.activer.length == 0 || this.state.activer.length == 'undefined'){
            this.handleNotificationClick("tr", 3, "No changes applicable");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
        }
        else{
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file_id', this.state.file_id);
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.activer));
        data.append('userGroup', decoded.userGroup);
        data.append('party_master_id', this.state.party_master_id);
        axios.post(config.get('API_URL') + "/brandemi/active_updater", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                    this.props.history.push('/admin/brand-product-master')
                } 
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })

        }
        
    };
    
    changeStatus(index, stored_file_name, file_id, user_id, checked) {
        //let status = 0;
        //if(checked===true){ status = 1 } else { status = 0 }
        this.setState({
            activer: {...this.state.activer, [file_id]:checked }
        })
    }

    uploadDropdownHandler = () => {
        this.setState({
            uploadDropdown: true
        })
    }

    toggleErrorModel() {
        this.setState({
            errorModel: !this.state.errorModel
        });
    }

    downloadReport(){
        console.log(this.state.report_file_name);
        this.downloadReportCSV.bind(this, 1, this.state.report_file_name, this.state.report_download_name);
    }



    toggleNoErrorModel() {
        this.setState({
            noErrorModel: !this.state.noErrorModel
        });
    }

    gotoUploadedFile(){
        let pusher = '/admin/brand-viewer/' + this.state.file_id_got
        this.props.history.push(pusher)
    }


    render() {
        console.log(this.state.activer);

        let brand_file_data = this.state.brand_file_uploaded.map((value, index) =>{
            console.log(this.state.activer);
            let timer2 = new Date(value.record_update_timestamp)
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            //let timer3 = timer2.getDay() + "-" + timer2.getMonth() + "-" + timer2.getFullYear() + " " + timer2.getHours() + ":" + timer2.getMinutes();
            return (
                <tr key={index + 1}>
                <td>{value.file_name}</td>
                <td>{timer3}</td>
                {/* <td>
                    {console.log(this.state.activer[index])}
                    {console.log(value.active_status)}
                <Switch className="react-switch" height={20} width={38} id={value.stored_file_name} onChange={this.changeStatus.bind(this, index, value.stored_file_name, value.id, value.user_id)} checked={(this.state.activer[value.id])? true : false}></Switch>
                </td> */}
                <td>
                    <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                    <Link className="viewButton" data-tip="Download File" onClick={this.downloadCSV.bind(this, value.id, value.file_name)}><span className="glyphicon glyphicon-download-alt" aria-hidden="true"></span></Link>
                    &nbsp;
                    <Link className="viewButton" data-tip="View"  to={"/admin/brand-viewer/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                </td>
            </tr>
            )
        });

        let error_message = this.state.error_message;
        let error_message_headere = () => {
            let value_header = this.state.error_message_header;
            if(value_header == 'Failure'){
                return(
                    <div className="row">
                        <div className="col-md-12"> 
                            <div className="redtexter">{value_header}</div>
                        </div>    
                    </div>
                );
            }
            else if(value_header == 'Success'){
                return(
                    <div className="row">
                        <div className="col-md-12"> 
                            <div className="greentexter">{value_header}</div>
                        </div>    
                    </div>
                );
            }
        }
        
        let link_to_show = () => {
            if (this.state.error_message_header == 'Success'){
                return(
                    <a href="#" onClick={this.gotoUploadedFile.bind(this)}>View</a>
                );
            }
            else if (this.state.error_message_header == 'Failure'){
                return(
                    <a href="#" onClick={this.downloadReportCSV.bind(this, 1, this.state.report_file_name, this.state.report_download_name)}>View report</a>
                )
            }
            else{
                return(
                    <div></div>
                )
                
            }
            
        }

        return (
            <div className="longcontent">
                <CommonNavbar/>
            <div className="container-fluid">
            <div className="card-query-builder pt-5">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <Modal className="modalsmall" isOpen={this.state.open_instructions} 
                    toggle={this.openInstructions.bind(this)} 
                    size="lg"
                    >
                    <ModalHeader>Instructions</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-md-12">
                            - Keep .csv encoding in UTF-8 format<br/>
                            - Mandatory fields are brand, category, model_number, model_name, model_description, sku, mop and mrp<br/>
                            - sku and model_description should be unique<br/>
                            - Avoid using special characters<br/>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" className="btn-capitalize2" onClick={this.openInstructions.bind(this)}>Close</Button>
                    </ModalFooter>
                </Modal>   
                <div className="pt-5" >
                    <div className="card">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="header">
                            <h4 className="title pull-left">Products</h4>
                            <button onClick={this.uploadDropdownHandler} className="btn btn-primary btn-capitalize pull-right">Import</button>
                        </div>
                        <div className="content">
                            <div className="row">
                                <div className="container-fluid">
                                    <div className="table-full-width table-responsive-bemi notablerightmargin top-pad-5">    
                                        <table className="table table-striped table-hover" id="brandViewTable">
                                            <thead>
                                                <tr>
                                                    <th>File Name</th>
                                                    <th>Upload Time</th>
                                                    {/* <th>Active</th> */}
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {brand_file_data}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className ="col-md-12">
                                    {/* <button onClick={this.activeHandler} className="btn btn-primary btn-capitalize pull-right">Update</button> */}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Collapse isOpen={this.state.uploadDropdown}>
                    <div className="col-md-4">
                        <div className="card pm-height">
                            <div className="header">
                                <h4 className="title">Step 1: Download Template</h4>
                            </div>
                            <hr/>
                            <div className="content">
                                <div className="row">
                                    <div className="col-md-12 pull-centere">
                                        <Button color="primary" className="btn-capitalize pull-centere" name="download" onClick={this.downloadCSV.bind(this, '7xhmd38Hhdad3_brand_product_master_template.csv', 1)}>Download Template</Button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 pull-centere">
                                        <a href="#" className="pull-center" onClick={this.openInstructions.bind(this)}>View Instructions</a>
                                    </div>
                                </div>
                                <div className="row">
                                    <br/>
                                </div>
                                <div className="row">
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card pm-height">
                            <div className="header">
                                <h4 className="title">Step 2: Upload Template</h4>
                            </div>
                            <hr/>
                            
                                <form method="post" action="#" id="#">
                                    
                                        <div className="col-md-12 pull-centere">
                                            <div className="form-group form-bottom">
                                                <label htmlFor="queryName" className="pull-centere">Upload</label>
                                                <input type="file" name="file" className="form-control pull-centere" onChange={this.onChangeHandler} />
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="button" className="btn btn-primary btn-capitalize" onClick={this.fileUploadHandler} disabled={this.state.isSubmit}>Upload File</button>
                                                </div>
                                            </div>
                                        </div>
                                    
                                </form>
                            
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card pm-height">
                            <div className="header">
                                <h4 className="title">Step 3: Results</h4>
                            </div>
                            <hr/>
                            <div className="content">
                                {error_message_headere()}
                                <div className="row">
                                    <div className="col-md-12">
                                        {error_message}
                                    </div>  
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {link_to_show()}
                                    </div>    
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
            </div>
            </div>
        );
    }
}

export default BrandProductMaster;